var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2316_9045)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.33237C10.5 3.15965 10.434 2.99202 10.307 2.8701L7.6299 0.193033C7.50798 0.0711176 7.34035 0 7.16763 0H7V3.5H10.5V3.33237ZM10.5 7.36575V4.37373H6.78157C6.4209 4.37373 6.12627 4.0791 6.12627 3.71843V0H0.655298C0.29463 0 0 0.29463 0 0.655298V13.3396C0 13.7003 0.29463 13.9949 0.655298 13.9949H9.83962C10.2003 13.9949 10.4949 13.7003 10.4949 13.3396V7.36575H10.5ZM8.16836 7.87373V6.09071C8.16836 5.69956 7.69594 5.50653 7.42163 5.78084L4.80552 8.41727C4.62264 8.60015 4.62264 8.89478 4.80552 9.07257L7.42163 11.709C7.69594 11.9884 8.16836 11.7903 8.16836 11.3991V9.61611H14.5893C14.8128 9.61611 14.9956 9.43324 14.9956 9.20972V8.27504C14.9956 8.05153 14.8128 7.86865 14.5893 7.86865H8.16836V7.87373Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2316_9045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9956,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportFile);
export default ForwardRef;